import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from './products.config';

export const VEHICLE_DATA_SOURCE = {
  MANUAL: 'MANUAL',
  NO_VEHICLE_REG_NO: 'NO_VEHICLE_REG_NO'
};

export const VEHICLE_REGISTRY_MODES = [
  VEHICLE_DATA_SOURCE.MANUAL,
  VEHICLE_DATA_SOURCE.NO_VEHICLE_REG_NO
];

export const VEHICLE_FUEL_TYPE_LIST = [
  { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_FUEL_TYPE.ELECTRICITY', value: 'ELECTRICITY' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_FUEL_TYPE.PETROL', value: 'PETROL' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_FUEL_TYPE.PETROL_GAS', value: 'PETROL_GAS' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_FUEL_TYPE.PETROL_85', value: 'PETROL_85' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_FUEL_TYPE.PETROL_HYBRID', value: 'PETROL_HYBRID' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_FUEL_TYPE.PETROL_PLUGIN_HYBRID', value: 'PETROL_PLUGIN_HYBRID' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_FUEL_TYPE.DIESEL', value: 'DIESEL' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_FUEL_TYPE.DIESEL_GAS', value: 'DIESEL_GAS' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_FUEL_TYPE.BIO_DIESEL', value: 'BIO_DIESEL' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_FUEL_TYPE.DIESEL_HYBRID', value: 'DIESEL_HYBRID' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_FUEL_TYPE.DIESEL_PLUGIN_HYBRID', value: 'DIESEL_PLUGIN_HYBRID' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_FUEL_TYPE.PARAFFIN', value: 'PARAFFIN' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_FUEL_TYPE.GAS', value: 'GAS' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_FUEL_TYPE.LNG', value: 'LNG' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_FUEL_TYPE.LPG', value: 'LPG' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_FUEL_TYPE.HYDROGEN', value: 'HYDROGEN' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_FUEL_TYPE.UNDISCLOSED', value: 'UNDISCLOSED' },
  { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_FUEL_TYPE.OTHER', value: 'OTHER' }
];

export function vehicleRegistryInput(order: number, options?: {
  required?: boolean;
  modes?: string[];
  registryOnly?: boolean;
}) {
  const required = !options || options.required !== false;

  return {
    vehicleRegistryOrder: order,
    vehicleDataSourceModes: options?.modes || VEHICLE_REGISTRY_MODES,
    omitEmptyString: true,
    ...(options?.registryOnly ? { vehicleRegistryField: true } : {}),
    vehicleRegistryInput: {
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', required ? [Validators.required] : []]
    }
  };
}

export function vehicleFuelTypeInput(order: number) {
  return {
    ...vehicleRegistryInput(order),
    vehicleRegistryInput: {
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [Validators.required]],
      settings: {
        list: VEHICLE_FUEL_TYPE_LIST
      }
    }
  };
}

export function vehicleRegistryProperty(
  name: string,
  key: string,
  order: number,
  options?: { required?: boolean; modes?: string[]; group?: string }
) {
  return {
    name,
    key,
    group: options?.group || 'OBJECT_INFO',
    ...vehicleRegistryInput(order, { ...options, registryOnly: true })
  };
}

export function vehicleChassisProperty(order: number) {
  return vehicleRegistryProperty(
    'tffVehicleChassisNumber',
    'TFF_VEHICLE_CHASSIS_NUMBER',
    order,
    { modes: [VEHICLE_DATA_SOURCE.NO_VEHICLE_REG_NO] }
  );
}

export function isVehicleRegistryPropertyVisible(property: any, vehicleDataSource: string | null | undefined): boolean {
  if (!property) {
    return false;
  }

  if (property.hideWhenVehicleDataSource && vehicleDataSource) {
    return false;
  }

  if (property.vehicleRegistryField && !vehicleDataSource) {
    return false;
  }

  if (
    property.vehicleDataSourceModes &&
    vehicleDataSource &&
    !property.vehicleDataSourceModes.includes(vehicleDataSource)
  ) {
    return false;
  }

  return true;
}
